module.exports = __webpack_public_path__ + "static/img/theme_default.9b98e000.png";